import { getMeta } from "app/utils/meta";
import { getLoaderTrans } from "app/.server/utils";
import Layout from "app/components/layout";
import {
  ExpandIntoUntappedSection,
  SeeHowCCommerceSection,
} from "app/sections/who-we-serve";

export const loader = async ({ request, params }) => {
  const trans = await getLoaderTrans({ request, params });

  return {
    meta: {
      title: `${trans("Who We Serve")} | ${trans("Businesses of all shapes and sizes")}`,
      description: trans(
        "If you’re a new or well-established business looking to tap into an all-new sales channel, we’ve got something for you."
      ),
    },
  };
};

export const meta = ({ loaderData: data }) => {
  return getMeta({
    title: data.meta.title,
    description: data.meta.description,
  });
};

export default function WhoWeServePage() {
  return (
    <Layout headerIsOnTop={false} enableHeaderShrinkingOnScroll={false}>
      <ExpandIntoUntappedSection />
      <SeeHowCCommerceSection />
    </Layout>
  );
}
